module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "glry"
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('div', [_c('p', [_c('b', [_vm._v(_vm._s(item.NAME))])]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(item.SEX) + "，" + _vm._s(item.XRZW) + "，" + _vm._s(item.PZWH) + "，" + _vm._s(item.RXZSJ) + "任现职\n      "), _vm._l((item.XGJL), function(jl) {
      return (jl.title !== '无') ? _c('span', [_vm._v("； " + _vm._s(jl.title) + _vm._s(jl.text))]) : _vm._e()
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "margin-b"
    })])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b52d60e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/xxgs/nr/glry.vue
// module id = 895
// module chunks = 2